<template>
    <div class="form-group">
        <label>{{ LabelInput }}</label>
       <!-- <input :value="checkId" type="hidden">
        <input :value="validate" type="hidden"> -->
        <v-select
                class=""
                :value="value"
                @input="$emit('input', $event)"
                @search="onSearchClientes"
                :filterable="false"
                :reduce="item => item.key"
                :options="clientes"
                placeholder="Buscar por Nombre"
                :clearable="false"
                :disabled="configInput.disabled"
        >

            <template slot="no-options">
                No hay clientes
            </template>

            <template slot="option" slot-scope="option">
                <div class="row">
                    
                    <div class="col-10 col-sm-10 col-md-11 col-lg-12 col-xl-12">
                        <b>{{ option.label }}</b>
                        <!--<div class="row">
                            <div class="col-12"  >
                                <small>Clave: {{ option.detalle.clave }}</small>
                            </div>
                        </div>-->
                    </div>

                </div>
            </template>

        </v-select>

        <slot></slot>

    </div>
</template>

<script>
export default {

    props: [
        'value',
        'pDisabled',
        'ptextLabel'
    ],

    data() {
        return {
            LabelInput: 'Cliente',
            localValue: 0,
            form: this.value,

            clientes: [],
            debounce: null,
            configInput:{
                disabled: false,
            }
        }
    },

    created(){
        if (this.ptextLabel != undefined ) {
            this.LabelInput = this.ptextLabel;
        }
    },

    methods: {
        setArrClientes (pCliente){
            this.clientes = [];
            let item = {
                label: pCliente.Nombre,
                key: pCliente.IdCliente
            }
            this.clientes.push(item);
        },

        onSearchClientes( search, loading ) {
            
            // PREVENTOR DE RE-BUSQUEDA EN BLANCO
            if(search != '' && search != undefined) { 
                this.clientes = [];

                clearTimeout( this.debounce );

                loading(true);

                this.debounce = setTimeout( async () => {

                    await this.getClientes( search, loading );

                }, 900);
            }
        },

        async getClientes( search, loading ) {

            const res = await this.$http.get( '/clientes', {
                params: {
                    TxtBusqueda: search,
                    Estatus: 'A',
                    Entrada: 10,
                    Pag: 1
                }
            });

            loading(false);

            if ( res.status != 200 ) {

                this.clientes = [];

            };


            this.clientes = res.data.data.data.map( (item) => ({
                label: `${item.Nombre}`,
                detalle: {
                    clave: item.Clave,
                    Rfc: item.Rfc,
                },
                key: item.IdCliente
            }) );

        },

    },
    computed:{
        /*checkId: function (){
            this.localValue = parseInt(this.value);
        },

        validate: function (){
            if(this.pDisabled != undefined){
                this.configInput.disabled = this.pDisabled
            }
        }*/
    }

}
</script>

<style>

</style>
